import { render, staticRenderFns } from "./SubmissionServerTable.vue?vue&type=template&id=0aded55a"
import script from "./SubmissionServerTable.vue?vue&type=script&lang=js"
export * from "./SubmissionServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports